import { Box, styled } from "@mui/material";
import { colors } from '../../../../theme/colors';

export const CreateJobWrapper = styled(Box)({
  padding: "24px",
  background: "linear-gradient(135deg, #fef6f6 0%, #f8f9fb 100%)",
  minHeight: "100%",

  "& .page-header": {
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "1px solid #e8eef5",
  },
  "& .page-title": {
    fontSize: "28px",
    fontWeight: 700,
    color: colors.primary,
    lineHeight: 1.2,
    marginBottom: "6px",
  },
  "& .page-subtitle": {
    fontSize: "14px",
    color: "#637381",
    lineHeight: 1.5,
  },

  "& .form-card": {
    background: "#ffffff",
    border: "1px solid #dde7f0",
    borderRadius: "20px",
    padding: "28px",
    boxShadow: "0 10px 30px rgba(127, 29, 29, 0.08)",
    maxWidth: "1000px",
  },

  "& .section-block": {
    marginBottom: "32px",
  },
  "& .section-title": {
    fontSize: "16px",
    fontWeight: 700,
    color: colors.primary,
    marginBottom: "20px",
    paddingBottom: "12px",
    borderBottom: "1px solid #e8eef5",
  },

  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    "& fieldset": {
      borderColor: "#d6e0ea",
    },
    "&:hover fieldset": {
      borderColor: colors.primary,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary,
      borderWidth: "1.5px",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#637381",
    "&.Mui-focused": {
      color: colors.primary,
    },
  },

  "& .job-id-field .MuiOutlinedInput-root": {
    backgroundColor: "#f5f7fa",
  },

  "& .budget-field .MuiInputAdornment-root": {
    color: colors.primary,
    fontWeight: 600,
  },

  "& .editor-label": {
    fontSize: "14px",
    fontWeight: 600,
    color: colors.primary,
    marginBottom: "8px",
  },
  "& .quill-container": {
    "& .ql-toolbar": {
      borderTopLeftRadius: "12px",
      borderTopRightRadius: "12px",
      backgroundColor: colors.primaryLight,
      borderColor: "#d6e0ea",
    },
    "& .ql-container": {
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px",
      borderColor: "#d6e0ea",
      minHeight: "150px",
      fontSize: "14px",
    },
  },

  "& .upload-area": {
    marginTop: "8px",
  },
  "& .upload-dropzone": {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    border: "1px dashed #d6e0ea",
    borderRadius: "12px",
    padding: "12px 16px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: "#f9fafb",
    "&:hover": {
      borderColor: colors.primary,
      backgroundColor: "#f0f4f8",
    },
  },
  "& .upload-icon": {
    fontSize: "24px",
    color: colors.primary,
  },
  "& .upload-text": {
    fontSize: "13px",
    fontWeight: 600,
    color: colors.primary,
  },
  "& .upload-hint": {
    fontSize: "12px",
    color: "#919EAB",
    marginLeft: "auto",
  },
  "& .uploaded-file": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    border: "1px solid #d6e0ea",
    borderRadius: "12px",
    backgroundColor: colors.primaryLight,
  },
  "& .file-info": {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  "& .file-icon": {
    color: colors.primary,
    fontSize: "28px",
  },
  "& .file-name": {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1a1a1a",
  },
  "& .file-size": {
    fontSize: "12px",
    color: "#919EAB",
  },

  "& .form-actions": {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "24px",
    paddingTop: "20px",
    borderTop: "1px solid #e8eef5",
  },
  "& .cancel-btn": {
    textTransform: "none",
    borderColor: "#d6e0ea",
    color: colors.primary,
    borderRadius: "12px",
    padding: "10px 24px",
    fontWeight: 500,
    fontSize: "15px",
    "&:hover": {
      borderColor: colors.primary,
      backgroundColor: "rgba(127, 29, 29, 0.04)",
    },
  },
  "& .save-btn": {
    minWidth: "170px",
    height: "48px",
    borderRadius: "12px",
    backgroundColor: colors.primary,
    textTransform: "none",
    color: "#fff",
    fontWeight: 600,
    fontSize: "15px",
    boxShadow: "0 8px 18px rgba(127, 29, 29, 0.18)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      boxShadow: "0 10px 22px rgba(127, 29, 29, 0.22)",
    },
    "&.Mui-disabled": {
      backgroundColor: colors.buttonDisabled.background,
      color: colors.buttonDisabled.color,
      opacity: 1,
      cursor: "not-allowed",
    },
  },

  "& .MuiMenuItem-root": {
    borderRadius: "8px",
    margin: "4px 8px",
    "&:hover": {
      backgroundColor: `${colors.primary} !important`,
      color: "#fff",
    },
  },

  "@media (max-width: 900px)": {
    padding: "16px",

    "& .form-card": {
      padding: "20px",
      borderRadius: "16px",
    },
    "& .page-title": {
      fontSize: "24px",
    },
    "& .form-actions": {
      flexDirection: "column-reverse",
    },
    "& .save-btn, & .cancel-btn": {
      width: "100%",
    },
  },
});
